import { assign, AssignAction } from 'xstate';

import { MICRO_ESTIMATION_INCREMENTING_STEPS } from './state';

import { MicroEstimationContext, MicroEstimationtEvent } from '.';

export const getStepTotal = () => MICRO_ESTIMATION_INCREMENTING_STEPS.length;

export const assignStepProgress = (
  stepNumber: number,
): AssignAction<MicroEstimationContext, MicroEstimationtEvent> =>
  assign((context) => ({
    ...context,
    stepProgress: { ...context.stepProgress, current: stepNumber },
  }));
